import { call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';

export function* sprintInsuranceConfirmNavigate() {
  yield call(authenticateUser);
};

export function* bypassedInsuranceConfirmNavigate() {
  yield call(authenticateUser);
};

